import { useCallback, useRef, type KeyboardEvent, type MouseEvent } from 'react'
import { Input } from '@panwds/react-ui'
import { addFavoritedNavItem, forceRerenderLeftNav } from '../framework/actions'
import type { FavoritePreference } from '../framework/stateTypes'

const preventDefault = (e: KeyboardEvent<HTMLInputElement> | MouseEvent<HTMLInputElement>) => {
  e.stopPropagation()
  e.preventDefault()
}
const EditFavorite = ({
  favorite, setEditPath,
}: {
  favorite: FavoritePreference
  setEditPath: (path: string) => void
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const onConfirm = useCallback(() => {
    const newName = inputRef.current?.value?.trim()
    if (newName && newName !== favorite.name) {
      addFavoritedNavItem({ ...favorite, name: newName })
    }
    setEditPath('')
    forceRerenderLeftNav()
  }, [favorite, setEditPath])
  const onKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onConfirm()
    }
    else if (e.key === 'Escape') {
      setEditPath('')
      forceRerenderLeftNav()
    }
  }, [onConfirm, setEditPath])

  return (
    <Input
      ref={inputRef}
      size='sm'
      autoFocus
      addClassName='twsf-bg-steel-gray-100 twsf-px-2'
      defaultValue={favorite.name}
      onBlur={onConfirm}
      onKeyDown={onKeyDown}
      onKeyUp={preventDefault}
      onClick={preventDefault}
    />
  )
}

export default EditFavorite
